import { createSlice } from '@reduxjs/toolkit'

export const virtualApiUserTokenSlice = createSlice({
  name: 'token',
  initialState: '',
  reducers: {
    setToken: (state, action) => {
      return action.payload
      // return payload
    },
  },
})

export const { setToken } = virtualApiUserTokenSlice.actions
